import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { COLORS } from 'modules/core/theme/colors';

import { PanelTitle, TitleContainer, StepNumber, StepName } from '../../styles';
import { StatusBlock, StatusIcon, StatusMessage } from './styles';
import { IAvailableDealStructureStatus } from '../../types';
import { POLICY_DEAL_STRUCTURE_STATUSES } from '../../consts/consts';

interface IAvailableDealStructureTitle {
  availableDealStructureStatus: IAvailableDealStructureStatus;
  isDisplayPolicyStatusMessage: boolean;
  stepNumber: number;
  shouldPromptResubmit?: boolean;
  isResubmitForPricing?: boolean;
}

export const AvailableDealStructureTitle: FC<IAvailableDealStructureTitle> = ({
  availableDealStructureStatus,
  isDisplayPolicyStatusMessage,
  stepNumber,
  shouldPromptResubmit = false,
  isResubmitForPricing = false,
}) => {
  const { t } = useTranslation();

  const getStatusMessage = useCallback(() => {
    if (POLICY_DEAL_STRUCTURE_STATUSES.includes(availableDealStructureStatus)) {
      return isDisplayPolicyStatusMessage && availableDealStructureStatus.message;
    }

    return availableDealStructureStatus.message;
  }, [availableDealStructureStatus, isDisplayPolicyStatusMessage]);

  return (
    <PanelTitle>
      <TitleContainer>
        <StepNumber>{t('components.loanVariablesModal.labels.step', { stepNumber })}</StepNumber>
        <StepName>
          {t(
            isResubmitForPricing
              ? 'components.loanVariablesModal.labels.currentDealStructure'
              : 'components.loanVariablesModal.labels.availableDealStructure',
          )}
          {shouldPromptResubmit && !isResubmitForPricing && (
            <StatusMessage color={COLORS.RED_6}>
              {' '}
              ({t('components.loanVariablesModal.infoMessages.resubmitForUpdatedPricing')})
            </StatusMessage>
          )}
        </StepName>
        <StatusBlock>
          <StatusMessage color={availableDealStructureStatus.color}>{getStatusMessage()}</StatusMessage>
          <StatusIcon imgSrc={availableDealStructureStatus.imageSrc} />
        </StatusBlock>
      </TitleContainer>
    </PanelTitle>
  );
};
